import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';

@Injectable({ providedIn: 'root' })
export class TimezoneService {
  getUserTimezone(): string {
    const stored = localStorage.getItem('timezone');
    if (!stored || stored === 'local') {
      return moment.tz.guess();
    }
    return stored;
  }

  convertToUserTimezone(utcTime: string): string {
    const timezone = this.getUserTimezone();
    return moment.utc(utcTime).tz(timezone).format('YYYY-MM-DD HH:mm:ss');
  }

  getUTCOffsetValue(): string {
    const zone = this.getUserTimezone();
    const offsetMinutes = moment.tz(zone).utcOffset();
    const offsetHours = offsetMinutes / 60;
    return offsetHours >= 0 ? `+${offsetHours}` : `${offsetHours}`;
  }

  getUserTimezoneOffsetLabel(): string {
    const zone = this.getUserTimezone();
    const offset = moment.tz(zone).utcOffset();
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset >= 0 ? '+' : '-';
    return `(UTC ${sign}${hours}:${minutes < 10 ? '0' + minutes : minutes}) ${zone}`;
  }
}